import { render, staticRenderFns } from "./IconSvgAFPMLiveEvent.vue?vue&type=template&id=7af17d52&scoped=true&"
import script from "./IconSvgAFPMLiveEvent.vue?vue&type=script&lang=js&"
export * from "./IconSvgAFPMLiveEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af17d52",
  null
  
)

export default component.exports